export var TransformationType;
(function (TransformationType) {
    TransformationType["PowerAutomateExpressionTemplate"] = "PowerAutomateExpressionTemplate";
    TransformationType["ComplexExpression"] = "ComplexExpression";
    TransformationType["InlineExpression"] = "InlineExpression";
})(TransformationType || (TransformationType = {}));
